<template src="./ask-tips.html"></template>

<script lang="ts">
import iaConfig from 'widgets/instant-answers/instant-answers.config'

export default {
  computed: {
    columns() {
      return [
        this.getCol('askTips.how', 'ol'),
        this.getCol('askTips.topics', 'ul'),
        this.getCol('askTips.support', 'p')
      ].filter(col => col) // filters out null columns
    },
    headingLevel() {
      return iaConfig.headingLevel + 1
    }
  },
  methods: {
    getCol(msgPrefix, tag) {
      const title = this.$msg(`${msgPrefix}.title`)
      if (!title) { return null }
      return {
        title,
        tag,
        items: this.getListItems(msgPrefix)
      }
    },
    getListItems(msgPrefix) {
      const listItems = []
      for (let i = 1; i <= 10; i++) {
        const text = this.$msg(`${msgPrefix}.${i}`)
        if (!text || text.indexOf('<?') === 0) {
          continue
        }
        listItems.push(text)
      }
      return listItems
    }
  }
}
</script>

<style lang="scss" src="./ask-tips.scss"></style>
